export default [
  {
    name: 'empFindList',
    method: 'get',
    desc: '获取同事列表',
    path: '/obt/empFindList',
    params: {
      count: 20,
      pageNum: 1,
      queryStr: '',
      cplx: '',
      deptId: ''
    }
  }, {
    name: 'vipEmpContactsPage',
    method: 'get',
    desc: '获取常旅客列表',
    path: '/obt/vipEmpContactsPage',
    params: {
      'count': 20,
      'pageNum': 1,
      'cplx': null,
      'queryStr': '',
      'contactsId': null,
      'clkFlag': null,
      tripType: ''
    }
  }, {
    name: 'vipEmpContactsDel',
    method: 'get',
    desc: '删除常用旅客',
    path: '/obt/vipEmpContactsDel',
    params: {
      contactsId: ''
    }
  }, {
    name: 'vipEmpContactsEdit',
    method: 'post',
    desc: '编辑常旅客',
    path: '/obt/vipEmpContactsEdit',
    params: {
      'birthPlace': '',
      'born': '',
      'chName': '',
      'clkFlag': null,
      'contactsId': null,
      'email': '',
      'empId': '',
      'enName': '',
      'idNumber': '',
      'otherNumber': '',
      'otherPeriod': '',
      'passport': '',
      'passportPeriod': '',
      'phoneNumber': '',
      'placeOfIssue': '',
      'relation': '',
      'sex': '',
      'tel': '',
      'psgType': '',
      cardType: '',
      nation: '',//国籍
      cardNo: '',
      cardName: ''

    }
  }, {
    name: 'vipEmpSaveDetail',
    method: 'post',
    desc: '简化版新增员工',
    path: '/obt/vipEmpSaveDetail',
    params: {
      deptId: '',
      nation: '',
      empName: '',
      empNo: '',
      phoneNumber: '',
      born: '',
      passport: '',
      passportPeriod: '',
      otherNumber: '',
      otherPeriod: '',
      idNumber: '',
      passportDateOfIssue: '',
      otherDateOfIssue: '',
      cardType: '',//证件类型的天津
      cardNo: '',
      cardName: '',
    }
  }, {
    name: 'vipEmpFindDetail',
    method: 'get',
    desc: '获取员工详情',
    path: '/obt/vipEmpFindDetail',
    params: {
      empId: ''
    }
  }, {
    name: 'vipEmpEditDetail',
    method: 'post',
    desc: '编辑员工详情',
    path: '/obt/vipEmpEditDetail',
    params: {
      isCivil: null,
      appBook: null,
      appTravel: null,
      approvalMode: null,
      assistant: '',
      birthPlace: '',
      bookOutside: null,
      bookRange: null,
      born: '',
      certificateType: '',
      deptId: '',
      dpDeptIds: '',
      empId: '',
      empName: '',
      empNo: '',
      email: '',
      empRank: null,
      engName: '',
      // idNumber: '',
      ifApprover: null,
      ifAutoCheckin: null,
      ifBooker: null,
      isValid: null,
      isdirector: null,
      jsxxyz: '',
      loginVip: null,
      maxDept: '',
      nation: '',
      otherNumber: '',
      otherPeriod: '',
      passport: '',
      passportPeriod: '',
      phoneNumber: '',
      phoneNumber2: '',
      placeOfIssue: '',
      popElevel: '',
      post: '',
      preference: '',
      pwd: null,
      roleIds: '',
      selectdeDept: '',
      sex: '',
      tel: '',
      // useAccount: null, //影响到对公问题所以注释
      passportDateOfIssue: '',
      otherDateOfIssue: '',
      cardType: '',//证件类型的天津
      cardNo: '',
      cardName: ''
    }
  }, {
    name: 'vipDeptFindList',
    method: 'post',
    desc: '获取部门列表',
    path: '/obt/vipDeptFindList',
    params: {
      'deptName': '',
      'count': 999,
      'pageNum': 1
    }
  }, {
    name: 'vipEmpDel',
    method: 'get',
    desc: '删除员工',
    path: '/obt/vipEmpDel',
    params: {
      id: ''
    }
  }, {
    name: 'vipEmpAddrGetList',
    method: 'get',
    desc: '企业员工查询常用地址列表信息',
    path: '/obt/vipEmpAddrGetList',
    params: {
      addrId: '',
      empId: ''
    }
  }, {
    name: 'vipEmpAddrEdit',
    method: 'post',
    desc: '企业员工修改常用地址',
    path: '/obt/vipEmpAddrEdit',
    params: {
      'addr': null,
      'area': null,
      'city': null,
      'email': null,
      'empAddrId': null,
      'empId': null,
      'isDefault': 0,
      'phoneNumber': null,
      'post': null,
      'province': null,
      'recipient': null
    }
  }, {
    name: 'vipEmpAddrDel',
    method: 'get',
    desc: '企业员工删除常用地址',
    path: '/obt/vipEmpAddrDel',
    params: {
      empAddrId: ''
    }
  },
  {
    name: 'gpIdValid',
    method: 'post',
    desc: 'GP身份信息验证',
    path: '/obt/plane/shopping/gpIdValid',
    params: {
      'psgName': '',
      'civilBankId': '',
      'idType': '',
      'idNo': '',
      'vcode': ''
    }
  }, {
    name: 'gpLoadVcode',
    method: 'post',
    desc: 'GP获取验证码图片地址',
    path: '/obt/plane/shopping/gpLoadVcode',
    params: {}
  }

]
